import React, { Component } from 'react';
import PSPDFKit from '../pspdfkit';
import {
  getDocumentContent,
  authenticate,
  loadAnnotations,
  saveAnnotations
} from '../../api/integration';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

const Permissions = {
  PRINT: 111,
  ADMIN: 10000
};

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

export class IntegrationViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presets: {},
      showInsertModal: false,
      uploadedFiles: [],
      totalPages: 0,
      selectedInsertIndex: 0,
      insertModalError: null,
      allowPrinting: false
    };
    this.internalSaveAnnotations = this.internalSaveAnnotations.bind(this);
  }

  async componentDidMount() {
    const client = this.props.match.params.client;
    const tenant = this.props.match.params.tenant;
    const documentId = this.props.match.params.superid;
    const stage = this.props.match.params.stage;
    const isCumulativeFolder =
      window.location.href.indexOf('cumulativefolder') >= 0;

    let annotations = null;
    let pdfContent = null;
    let tmpAnnotations = null;
    try {
      const token = await authenticate(client, isCumulativeFolder);
      console.log('got token', token);
      this.setState({ token });

      pdfContent = await getDocumentContent(token, tenant, documentId, stage);
      tmpAnnotations = await loadAnnotations(token, tenant, documentId, stage);
      if (
        tmpAnnotations !== null &&
        tmpAnnotations.instantJson &&
        tmpAnnotations.instantJson.annotationJSON
      ) {
        annotations = tmpAnnotations.instantJson.annotationJSON;
        if (annotations.pdfId) {
          annotations.pdfId = null;
        }
      }

      if (isCumulativeFolder) {
        const payload = parseJwt(token);
        const roles = payload.customRoles;
        if (
          roles.includes(Permissions.PRINT) ||
          roles.includes(Permissions.ADMIN) ||
          roles.length === 0
        ) {
          this.setState({ allowPrinting: true });
        }
      } else {
        this.setState({ allowPrinting: true });
      }

      this.setState((state, props) => {
        return {
          finishedLoading: true,
          pdfContent,
          annotations,
          stage,
          tenant
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  internalSaveAnnotations(instantJson, pageRotation) {
    if (!instantJson.pageRotation) {
      instantJson.pageRotation = pageRotation;
    }
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    saveAnnotations(
      this.state.token,
      this.state.tenant,
      documentId,
      instantJson,
      this.state.stage
    );
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
    return (
      <div className="App">
        {this.state.error && <div>{this.state.errorMessage}</div>}
        {this.state.finishedLoading && (
          <PSPDFKit
            documentId={this.props.match.params.superid}
            pdfUrl={this.state.pdfContent}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            instantJSON={this.state.annotations}
            saveAnnotations={this.internalSaveAnnotations}
            showDelete={false}
            client={this.props.match.params.client}
            hidePageOrder={true}
            hideInsert={true}
            hidePrint={!this.state.allowPrinting}
          />
        )}
      </div>
    );
  }
}

export default IntegrationViewer;
